<app-button
    [type]="eButtonType.WHITE"
    [shape]="eButtonShape.RECTANGLE"
    [buttonWidth]="'100%'"
    [iconSrc]="logoSrc"
    [iconAlt]="providerName"
    (onClick)="login()">
  {{(labelKey || eAuthMessages.SIGN_IN_WITH_PROVIDER) | translate: { provider: providerName } }}
</app-button>
